import { useContext, useCallback, useState } from 'react';
import styles from './SegmentedControl.module.scss.js';
import { SegmentedControlContext } from './SegmentedControlContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { HorizontalScrollableContext } from '../scrollable/HorizontalScrollableContext.js';
import { UNSAFE_Icon } from '../icon/Icon.js';
import { Popover } from '../popover/Popover.js';
import classNames from 'clsx';

function SegmentButton(_ref) {
  let {
    children,
    className: callerClassName,
    icon,
    disabled,
    iconPosition = 'start',
    id,
    tag = id
  } = _ref;
  const {
    selected,
    onSelect,
    variant
  } = useContext(SegmentedControlContext);
  const {
    showLeftArrow,
    showRightArrow
  } = useContext(HorizontalScrollableContext);
  const handleClick = useCallback(() => {
    onSelect(id);
  }, [id, onSelect]);
  const isOverflow = showLeftArrow || showRightArrow;
  const [showPopover, setShowPopover] = useState(false);
  const handleHoverEnter = useCallback(() => {
    setShowPopover(true);
  }, [setShowPopover]);
  const handleHoverExit = useCallback(() => {
    setShowPopover(false);
  }, [setShowPopover]);
  const className = classNames('dsx-component', styles.button, selected === id && styles.selected, (variant === 'small' || isOverflow) && styles.small, callerClassName);
  return /*#__PURE__*/jsx("button", {
    disabled: disabled,
    role: "tab",
    className: className,
    onClick: handleClick,
    onMouseEnter: handleHoverEnter,
    onMouseLeave: handleHoverExit,
    onFocus: handleHoverEnter,
    onBlur: handleHoverExit,
    "data-dsx--segment-button": tag,
    children: icon && iconPosition === 'start' ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
        className: styles.icon,
        icon: icon
      }), " ", children]
    }) : icon && iconPosition === 'end' ? /*#__PURE__*/jsxs(Fragment, {
      children: [children, " ", /*#__PURE__*/jsx(UNSAFE_Icon, {
        className: styles.icon,
        icon: icon
      })]
    }) : icon && iconPosition === 'icon-only' ? /*#__PURE__*/jsx(Popover, {
      isOpen: showPopover,
      contents: children,
      placement: "top",
      children: /*#__PURE__*/jsx(UNSAFE_Icon, {
        className: styles.icon,
        icon: icon
      })
    }) : children
  });
}

export { SegmentButton };
